export const ruleText =
  "（須超過8個字元，且至少包含1個英文字母與1個數字）";

export function isValid(value) {
  return (
    typeof value === "string" &&
    value.length > 8 &&
    /[A-Za-z]/.test(value) &&
    /[0-9]/.test(value)
  );
}
